import { Instagram, Facebook, MegaphoneOff } from "lucide-react";

export default function BroadcastBanner({ message }) {
  return (
    <div
      data-testid="broadcast-banner"
      className="sticky top-0 z-40 bg-gradient-to-r from-[#D9381E] via-[#B02A15] to-[#2C241B] text-white shadow-lg"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 w-9 h-9 shrink-0 rounded-full bg-white/15 flex items-center justify-center">
            <MegaphoneOff className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display font-extrabold text-base sm:text-lg leading-tight" data-testid="broadcast-title">
              Orders are currently closed
            </div>
            <div className="text-xs sm:text-sm text-white/90 mt-0.5 max-w-xl" data-testid="broadcast-message">
              {message?.trim() ||
                "Currently updating the website. Please come back when we announce that ordering is open again on our social media."}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 self-start sm:self-auto">
          <a
            href="https://www.instagram.com/hafaadaikitchen"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="broadcast-instagram-link"
            className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 bg-white/15 hover:bg-white/25 text-sm font-semibold transition-colors"
          >
            <Instagram className="w-4 h-4" /> Instagram
          </a>
          <a
            href="https://www.facebook.com/demetri.turpin.77"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="broadcast-facebook-link"
            className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 bg-white/15 hover:bg-white/25 text-sm font-semibold transition-colors"
          >
            <Facebook className="w-4 h-4" /> Facebook
          </a>
        </div>
      </div>
    </div>
  );
}
